import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  makeStyles,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  Paper,
  Typography,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import PersonIcon from "@material-ui/icons/Person";
import FeedbackIcon from "@material-ui/icons/Feedback";
import LockIcon from "@material-ui/icons/Lock";
import AssignmentIcon from "@material-ui/icons/Assignment";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

import firebase from "../../services/firebase";
import PlaidSetup from "./components/PlaidSetup";
import SplitwiseSetup from "./components/SplitwiseSetup";
import DeleteAccount from "./components/DeleteAccount";
import LoadingComponent from "../../components/LoadingComponent";

import SubscriptionComponent from "./components/Subscription";
import { fetchStripeData } from "../../redux/actions";
import {
  PRIVACY_POLICY_LINK,
  TERMS_LINK,
  FEEDBACK_LINK,
} from "../../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  subscriptionInfo: {
    marginTop: theme.spacing(2),
  },
  bold: {
    fontWeight: "bold",
  },
}));

const SettingsPage = ({ auth, profile, fetchStripeData }) => {
  const [loading, setLoading] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const classes = useStyles();
  useEffect(() => {
    fetchStripeData();
  }, []);
  const handleClickLogout = async () => {
    await firebase.auth().signOut();
  };
  const handleVerifyEmail = async () => {
    await firebase.auth().currentUserer.sendEmailVerification();
    setShowSnackBar(true);
  };
  const handleClickPrivacyPolicy = () => {
    window.open(PRIVACY_POLICY_LINK, "_new");
  };
  const handleClickTerms = () => {
    window.open(TERMS_LINK, "_new");
  };
  const handleClickFeedback = () => {
    window.open(FEEDBACK_LINK, "_new");
  };
  const isSubscriptionActive =
    profile && profile.subscription && profile.subscription.status === "active";

  return (
    <Paper className={classes.root}>
      <Typography>
        <b>Your plan</b>
      </Typography>
      <SubscriptionComponent />
      <List>
        <ListItem button onClick={handleClickLogout}>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          Logout {auth.email}
        </ListItem>
        {!auth.emailVerified && (
          <ListItem button onClick={handleVerifyEmail}>
            <ListItemIcon>
              <MailOutlineIcon />
            </ListItemIcon>
            Verify your email
          </ListItem>
        )}
        <SplitwiseSetup />
        <PlaidSetup />
        <DeleteAccount />
        <Divider />
        <ListItem button onClick={handleClickFeedback}>
          <ListItemIcon>
            <FeedbackIcon />
          </ListItemIcon>
          Send Feedback
        </ListItem>
        <ListItem button onClick={handleClickPrivacyPolicy}>
          <ListItemIcon>
            <LockIcon />
          </ListItemIcon>
          Privacy Policy
        </ListItem>
        <ListItem button onClick={handleClickTerms}>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          Terms & Conditions
        </ListItem>
      </List>
      {loading && <LoadingComponent />}
      <Snackbar
        open={showSnackBar}
        autoHideDuration={5000}
        onClose={() => setShowSnackBar(false)}
      >
        <Alert severity="info" elevation={6} variant="filled">
          Verification email sent!
        </Alert>
      </Snackbar>
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile,
});

export default connect(mapStateToProps, { fetchStripeData })(SettingsPage);
